/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - Category Management
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useCategory from "hooks/useCategory";

export default function data() {
  const navigate = useNavigate();
  const { getcategoryList, deletecategory, categoryList } = useCategory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({});

  const handleDeleteCategory = async (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      setLoading((prev) => ({ ...prev, [categoryId]: { ...prev[categoryId], delete: true } }));
      try {
        const res = await deletecategory(categoryId);
        if (res.success) {
          alert("Category deleted successfully!");
          fetchList();
        }
      } catch (err) {
        console.error("Error deleting category:", err);
        alert("An error occurred while deleting the category.");
      } finally {
        setLoading((prev) => ({ ...prev, [categoryId]: { ...prev[categoryId], delete: false } }));
      }
    }
  };

  const CategoryActions = ({ onEdit, onDelete, categoryId }) => (
    <MDBox display="flex" justifyContent="center">
      <MDButton variant="contained" color="info" onClick={onEdit} sx={{ mr: 1 }}>
        <EditIcon />
      </MDButton>
      <MDButton
        variant="contained"
        color="error"
        onClick={onDelete}
        sx={{ mr: 1 }}
        disabled={loading[categoryId]?.delete}
      >
        <DeleteIcon />
      </MDButton>
    </MDBox>
  );

  const CategoryInfo = ({ name, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const rows = data?.map((category) => ({
    category: <CategoryInfo name={category.name} image={category.image} />,
    image: (
      <img
        src={category.image}
        alt="Preview"
        style={{ height: "50px", width: "50px", objectFit: "contain" }}
      />
    ),
    actions: (
      <CategoryActions
        categoryId={category._id}
        onEdit={() => navigate(`/category-management/edit?id=${category._id}`)}
        onDelete={() => handleDeleteCategory(category._id)}
      />
    ),
  }));

  const fetchList = async () => {
    await getcategoryList();
  };

  useEffect(() => {
    if (categoryList.categories) {
      setData(categoryList.categories);
    }
  }, [categoryList]);

  return {
    columns: [
      { Header: "Category", accessor: "category", width: "50%", align: "left" },
      { Header: "Image", accessor: "image", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}
